export default "__VITE_ASSET__DO84aQrY__"